"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconsCardMedium = function IconsCardMedium(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16",
    height: "16",
    className: (0, _classnames.default)('Icon', 'IconsCardMedium', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M14.25 12.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 1 1 0-1.5h12.5zm0-3.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5h12.5zm0-3.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5h12.5zm0-3.5a.75.75 0 1 1 0 1.5H1.75a.75.75 0 0 1 0-1.5h12.5z"
  }));
};

var _default = IconsCardMedium;
exports.default = _default;